import React from 'react';

import { InfoTooltip } from '../../InfoTooltip/component.tsx';

import styles from './component.module.scss';

const Stat = ({
  title,
  mainValue,
  secondaryValue,
  tooltipContent,
  flex
}: {
  title: React.ReactNode;
  mainValue: React.ReactNode;
  secondaryValue?: React.ReactNode;
  tooltipContent?: React.ReactNode;
  flex?: string;
}) => {
  return (
    <div className={styles.main} style={{ flex }}>
      <span className={styles.title}>
        {title}
        {tooltipContent && <InfoTooltip content={tooltipContent} />}
      </span>
      <span className={styles.mainValue}>{mainValue}</span>
      {secondaryValue && (
        <span className={styles.secondaryValue}>{secondaryValue}</span>
      )}
    </div>
  );
};

export { Stat };
